import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useContext } from 'react';
import { BaseURL } from '../../Files/BaseURL';
import AlertContext from '../../Context/Alert/AlertContext';
import ThemeContext from '../../Context/theme/ThemeContext';
import ProfilePic from './ProfilePic';
import { trimDescription } from '../../Files/UseFunction';

const GigsCart = ({ item,fetchMarektProfile }) => {
    const{theme}=useContext(ThemeContext)
    const navigate = useNavigate();
    const alertContext = useContext(AlertContext);
    const { showAlert } = alertContext;

    const deletePortfolio = async (id) => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.delete(`${BaseURL}/api/portfolio/marketplace/${id}`, {
                headers: {
                    'auth-token': authToken
                }
            });
            if (response.status === 200) {
                fetchMarektProfile()
                showAlert('Portfolio item deleted successfully!', 'success');
                // Optionally, refresh the page or update the state to reflect the changes
            } else {
                showAlert('Failed to delete portfolio item.', 'danger');
            }
        } catch (error) {
            console.error('Error deleting portfolio item:', error);
            showAlert('An error occurred while deleting the portfolio item.', 'danger');
        }
    };

    return (
        <div
            className={`rounded-2xl flex flex-col gap-4 font-pop border-2 border-light py-2 px-4`}
        >
            <div className="flex flex-row justify-between">
                <div className="flex gap-2">
                    <div className='w-12 h-12 overflow-hidden rounded-full'>
                        <ProfilePic
                            profilePhoto={item.User.ProfilePhoto}
                            name={item.User.FirstName}
                        />
                    </div>
                    <div className="flex flex-col gap-0">
                        <div className="flex flex-row gap-1 items-center">
                        </div>
                        <h3 className='text-lg font-semibold'>{item.User.FirstName} {item.User.LastName}</h3>
                    </div>
                </div>
                <div className="flex gap-2 items-center z-20 justify-end top-2 right-2">
                    <div className="p-2 bg-gray-800/25 rounded-xl">
                        <img
                            src="../../../Assets/Prop/Edit.png"
                            alt=""
                            className='h-4 w-4 cursor-pointer'
                            onClick={() => { navigate(`/user-dashboard/profile/marketplace_creation?editid=${item._id}`) }}
                        />
                    </div>
                    <div className="p-2 bg-gray-800/25 rounded-xl">
                        <img
                            src="../../../Assets/Prop/Delete.png"
                            alt=""
                            className='h-4 w-4 cursor-pointer'
                            onClick={() => { deletePortfolio(item._id) }}
                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-row font-pop gap-1">
                {item.Keywords.slice(0, 2).map((item2, index2) => (
                    <div className={` rounded-full py-1 px-2 text-sm ${theme==="dark"?"bg-black text-white border border-white":"bg-white"}`} key={index2}>
                        {item2}
                    </div>
                ))}
                {item?.Keywords?.length > 2 && (
                    <div className='bg-[#EFFBF1] rounded-full p-1 text-sm'>
                        +{item.Keywords?.length - 2}
                    </div>
                )}
            </div>
            <div className="flex flex-col gap-2">
                <h2 className='font-medium '>{trimDescription(item?.Des)}</h2>
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-1">
                    {item.Images.map((item2, index2) => (
                        <div className="w-full h-36 overflow-hidden"  key={index2}>
                            <img src={item2.img} alt="" className='w-full object-cover rounded-xl h-full' />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default GigsCart;
